<ng-container *ngIf="isCreateMode() || isUpdateMode() || isReadMode()">
  <form (ngSubmit)="save()" [formGroup]="form">
    <base-form-header
      [mode]="mode"
      updateLabel="Modifier un bâtiment"
      createLabel="Créer un bâtiment"
    ></base-form-header>

    <mat-dialog-content fxLayout="column">
      <base-form-input
        *ngIf="isUpdatingFromEstablishment() || isCreatingFromEstablishment()"
        label="Établissement"
        type="text"
        [disableAutoSelect]="true"
        displayProperty="label"
        controlName="establishment"
      ></base-form-input>

      <base-form-input
        label="Catégorie générique de bâtiment"
        [items$]="genericBuildingCategory$"
        (autocompleteChange)="genericBuildingsCategoryAutocompleteChange($event)"
        (optionChange)="onGenericBuildingCategoryChange()"
        type="autocomplete"
        [disabled]="isReadMode()"
        displayProperty="label"
        controlName="genericBuildingCategory"
      ></base-form-input>

      <base-form-input
        label="Bâtiment générique"
        [items$]="genericBuildings$"
        (autocompleteChange)="genericBuildingsAutocompleteChange($event)"
        (optionChange)="onGenericBuildingChange()"
        [disabled]="isReadMode()"
        type="autocomplete"
        displayProperty="label"
        controlName="genericBuilding"
      ></base-form-input>

      <base-form-input
        label="Supervision métier"
        [items$]="contacts$"
        type="autocomplete"
        [disabled]="isReadMode()"
        displayProperty="fullName"
        controlName="contactIntern"
        (autocompleteChange)="contactInternAutocompleteChange($event)"
        (optionChange)="onContactInternChange()"
      ></base-form-input>

      <p
        *ngIf="isSupervisorInherited && inheritedSupervisorLabel; else manualSupervisor"
        class="caption text-secondary -mt-3 mb-4"
      >
        <mat-icon class="icon-sm align-middle mr-1">account_tree</mat-icon>
        {{ inheritedSupervisorLabel }}
      </p>
      <ng-template #manualSupervisor>
        <p *ngIf="hasManualContact" class="caption text-secondary -mt-3 mb-4">
          <mat-icon class="icon-sm align-middle mr-1">edit</mat-icon>
          Choix manuel
        </p>
      </ng-template>

      <base-form-input controlName="label" [disabled]="isReadMode()" label="Libellé"></base-form-input>

      <base-form-input controlName="customerDesignation" label="Dénomination client"></base-form-input>

      <base-form-input controlName="constructionDate" label="Date de construction" type="date"></base-form-input>

      <base-form-input
        label="Type de détention"
        type="autocomplete"
        [items$]="detentionType$"
        (autocompleteChange)="detentionTypeAutocompleteChange($event)"
        (optionChange)="onDetentionTypeChange()"
        [disabled]="isReadMode()"
        displayProperty="label"
        controlName="detentionType"
      ></base-form-input>

      <base-form-input
        *ngIf="showSupplierField"
        label="Bailleur / Propriétaire"
        type="autocomplete"
        [items$]="suppliers$"
        (autocompleteChange)="supplierAutocompleteChange($event)"
        [disabled]="isReadMode()"
        displayProperty="label"
        controlName="supplier"
      ></base-form-input>

      <base-form-input
        *ngIf="showLeaseTypeField"
        label="Type bail"
        type="autocomplete"
        [items$]="leaseTypes$"
        (autocompleteChange)="leaseTypeAutocompleteChange($event)"
        [disabled]="isReadMode()"
        displayProperty="label"
        controlName="leaseType"
      ></base-form-input>

      <base-form-input controlName="surface" label="Surface Totale (m²)" type="number"></base-form-input>

      <base-form-input
        *ngIf="isUpdatingFromEstablishment() || isCreatingFromEstablishment()"
        [disabled]="isReadMode()"
        controlName="usedSurface"
        [label]="'Surface utilisée (m²) par ' + getEstablishmentsName()"
        type="number"
      ></base-form-input>

      <p class="mb-3">Dates de dernière maintenance</p>
      <mat-divider class="mb-6"></mat-divider>
      <ng-container>
        <div class="flex flex-col sm:flex-row w-full">
          <base-form-input
            class="sm:mr-3 w-full"
            label="Maintenance réglementaire"
            controlName="lastRegulatoryMaintenanceDate"
            type="date"
            [disabled]="isReadMode()"
          ></base-form-input>
          <base-form-input
            class="sm:ml-3 w-full"
            label="Maintenance non réglementaire"
            controlName="lastMaintenanceDateOther"
            type="date"
            [disabled]="isReadMode()"
          ></base-form-input>
        </div>
      </ng-container>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <base-form-input
        (onCreate)="createItem()"
        (onUpdate)="updateItem()"
        [mode]="mode"
        entityLabel="BUILDING"
        type="submit"
      ></base-form-input>
    </mat-dialog-actions>
  </form>
</ng-container>

<ng-container *ngIf="isDeleteMode()">
  <form-modal-delete-base
    (onClose)="close()"
    (onDelete)="deleteItem()"
    [label]="data.name"
    [loading]="loading"
  ></form-modal-delete-base>
</ng-container>

<ng-container *ngIf="isImportMode()">
  <vex-form-import-base
    [modalTitle]="'Importer des bâtiments'"
    [entityLabel]="'Bâtiment'"
    [form]="importForm"
    [loading]="loading"
    [service]="service"
    [mode]="mode"
    (saveForm)="save()"
    (importItems)="importItems()"
    [canDownloadTemplateModel]="canDownloadTemplateModel"
    [collectionName]="'buildings'"
  ></vex-form-import-base>
</ng-container>

<ng-container *ngIf="isArchiveMode()">
  <form-modal-delete-base
    (onClose)="close()"
    (onDelete)="archiveItem()"
    defaultMessage="Êtes-vous sûr de vouloir archiver ce bâtiment ?"
    title="Archiver le bâtiment"
  ></form-modal-delete-base>
</ng-container>
